import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { QueryParameters as GetBrandPreferencesQueryParameters } from "@faire/web-api--source/endpoints/www/api/email/preferences/retailer-brand-preferences/get";
import {
  useQuery as useBrandPreferencesQuery,
  getQueryKey as getBrandPreferencesQueryKey,
} from "@faire/web-api--source/endpoints/www/api/email/preferences/retailer-brand-preferences/get-hooks";
import { QueryParameters as EmailPreferencesPageQueryParams } from "@faire/web-api--source/routes/www/retailer/settings/email-preferences";
import { keepPreviousData, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const PAGE_SIZE = 20;

export const useBrandSentEmailPreferencesQuery = () => {
  const { page } = useQueryParams(EmailPreferencesPageQueryParams.parse);
  const { emailAddress } = useUserStore();
  const queryClient = useQueryClient();

  const brandPreferencesQueryParameters =
    GetBrandPreferencesQueryParameters.build({
      emailAddress,
      pageSize: PAGE_SIZE,
      pageNumber: Number(page) || 1,
    });

  const {
    data: brandSubscriptionPreferences,
    isLoading,
    isError,
    isFetched,
  } = useBrandPreferencesQuery(brandPreferencesQueryParameters, {
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });

  const removeBrandPreferencesQueriesForAllPages = useCallback(() => {
    queryClient.removeQueries({
      predicate: (query) => {
        const expectedQueryKey = getBrandPreferencesQueryKey(
          brandPreferencesQueryParameters
        );
        return query.queryKey[0] === expectedQueryKey[0];
      },
    });
  }, [queryClient, brandPreferencesQueryParameters]);

  return {
    brandSubscriptionPreferences,
    isLoading,
    isError,
    isFetched,
    removeBrandPreferencesQueriesForAllPages,
  };
};
